export default "__VITE_ASSET__Cj4Qa7oL__"